import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './i18n'; // Importa la configuración de i18n
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next'; // Importa el proveedor de i18n
import i18n from 'i18next'; // Importa i18n para poder pasarlo al proveedor

// Importa las funciones necesarias de Firebase
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Tu configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAtQm3r5cPUWbCiaD6XzUNgMugI0aLWzdI",
  authDomain: "challenz-landing.firebaseapp.com",
  projectId: "challenz-landing",
  storageBucket: "challenz-landing.appspot.com",
  messagingSenderId: "363044724870",
  appId: "1:363044724870:web:07f654ae5c5ed04e5c7107",
  measurementId: "G-Y3VRNHLD7C"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Define un componente de respaldo para mostrar mientras los componentes están suspendidos
const LoadingFallback = () => (
  <div>Loading...</div>
);

ReactDOM.render(
  <I18nextProvider i18n={i18n}> {/* Envuelve tu App con el proveedor de i18n */}
    <Suspense fallback={<LoadingFallback />}> {/* Envuelve tu App con Suspense */}
      <App />
    </Suspense>
  </I18nextProvider>,
  document.getElementById('root')
);

// Si deseas comenzar a medir el rendimiento en tu aplicación, pasa una función
// para registrar resultados (por ejemplo: reportWebVitals(console.log))
// o enviar a un punto final de análisis. Aprende más: https://bit.ly/CRA-vitals
reportWebVitals();
